module.exports = __webpack_public_path__ + "img/map_layer_tick.ab7fb027.svg";